const DISPLAYABLE_ACTIVE_RIDER_STATUSES = new Set(["active", "approved"]);

export const normalizeRiderStatus = (status) =>
  String(status || "")
    .trim()
    .toLowerCase();

export const isDisplayableActiveRider = (rider = {}) =>
  rider?.activated === true &&
  DISPLAYABLE_ACTIVE_RIDER_STATUSES.has(normalizeRiderStatus(rider?.status));
